module.exports = __webpack_public_path__ + "static/media/ge-appliances.ce54f128.jpg";